export default __webpack_public_path__ + "static/media/Vedant-Tech-Logo-Transparent.b7ddff9b.png";